import React, { Component } from "react";
import { connect } from "react-redux";
import { appRedirect } from "app/NativeActions";
import { withRouter } from "react-router-dom";

class RedirectError extends Component {
  componentDidMount() {
    this.props.appRedirect({ redirect: "getStarted" });
  }

  render() {
    return <div />;
  }
}

export default withRouter(connect(null, { appRedirect })(RedirectError));
